module.exports = __webpack_public_path__ + "static/img/video-cover.c32e69c8.jpeg";